import React from "react";
import { FaCar, FaPlane } from "react-icons/fa";
import { IoMdTrain } from "react-icons/io";

const HowToReach = ({
    byAir,
    byCar,
    byRail
}) => {
    return (
        <div className="md:flex main-wrapper md:gap-8 pb-[40px] destination-path">
            {byCar && (
                <div className="pb-[24px] md:pb-0 min-w-[30%]">
                    <FaCar color="#03164f" size="40" />
                    {byCar}
                </div>
            )}
            {byRail && (
                <div className="pb-[24px] md:pb-0 min-w-[30%]">
                    <IoMdTrain color="#03164f" size="40" />
                    {byRail}
                </div>
            )}
            {byAir && (
                <div>
                    <FaPlane color="#03164f" size="40" />
                    {byAir}
                </div>
            )}
        </div>
    );
}

export default HowToReach;